import React from 'react';
import Branches from '../../Components/Branches';
import AppHeader from '../../Components/Common/Layout/AppHeader';
import { StyledDiv } from '../../Theme/CommonStyled';

const BranchesPage: React.FC = () => {
  return (
    <>
      <AppHeader title="contactUs" goBack />
      <StyledDiv
        direction="rtl"
        px={8}
        height={'calc(100vh - 60px)'}
        bg={'mainBackground'}
        overflow={'auto'}>
        <Branches />
      </StyledDiv>
    </>
  );
};

export default BranchesPage;
